import React from "react";
import Select from "react-select";

// Phase 1B. Reusable searchable user picker for Project/Module membership
// selection — same react-select usage pattern already established in
// src/pages/admins/SubCategory.js. `users` must already be the shape
// returned by GET /api/users (never includes password/text_pass — that is
// enforced server-side, not here). Shows employee name, employee code,
// designation and department separately, per the Phase 1B UI requirement.
export default function ProjectMemberPicker({
  users = [],
  excludeUserIds = [],
  value,
  onChange,
  placeholder = "Search by name, employee code, designation...",
  isDisabled = false,
}) {
  const excluded = new Set((excludeUserIds || []).map((id) => String(id)));

  const options = users
    .filter((u) => !excluded.has(String(u.id)))
    .map((u) => ({
      value: String(u.id),
      label: [
        u.name,
        u.role_name || null,
        u.employee_code ? `#${u.employee_code}` : (u.id != null ? `#${u.id}` : null),
        u.designation_name || null,
        u.department_name || null,
        u.email || null,
      ]
        .filter(Boolean)
        .join(" — "),
    }));

  const selected = options.find((o) => o.value === String(value)) || null;

  return (
    <Select
      classNamePrefix="member-picker"
      options={options}
      value={selected}
      onChange={(opt) => onChange(opt ? opt.value : "")}
      placeholder={placeholder}
      isClearable
      isDisabled={isDisabled}
      noOptionsMessage={() => "No eligible users found"}
      menuPortalTarget={typeof document !== "undefined" ? document.body : null}
      // Bootstrap <Modal> in this app renders at z-index 1320 (see
      // src/index.css) -- without portaling to document.body, this
      // dropdown's menu is clipped by the Modal's own overflow/stacking
      // context instead of floating freely above it (e.g. inside
      // TaskCreateForm's "Create Work Ticket" modal).
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 1400 }) }}
    />
  );
}
